module.exports = "/images/zh-Hans.svg";